import React from "react";
import { GoMarkGithub } from "react-icons/go";
import { AiOutlineLink } from "react-icons/ai";
import { Link } from "react-router-dom";

const ProjectCard = ({ p }) => {
  const { image, leng, prname ,client, Live, _id} = p;

  return (
    <div>
      <div
         data-aos="fade-up"
         data-aos-duration="3000"
        className="card card-compact w-[350px] mx-auto  bg-slate-500/50 shadow-xl border mb-4 border-blue-400"
      >
        <figure className="h-[280px]  relative">
          <img src={image} alt="Shoes" />
        </figure>
        
        <div className="card-body">
          <div className="flex  gap-4 items-center mb-2">
            <h2 className="text-2xl font-medium">{prname}</h2>{" "}
            <span className="text-red-400">|</span>
            <a target="blank" href={client}>
              <GoMarkGithub className="text-3xl text-blue-500 bottom-0 flex " />
            </a>
            <span className="text-red-400">|</span>
            <a target="blank" href={Live}>
              <AiOutlineLink className="text-3xl text-blue-500 bottom-0 flex " />
            </a>
          </div>

          <div>
            {leng.map((m) => (
              <button className="ml-2 mb-2 btn btn-xs">{m}</button>
            ))}
          </div>
          <div className="">
            <Link to={`/details/${_id}`}>
            <button className="btn btn-success  w-full">Details</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
